package pwgs.ui.scenes.userreportsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(UserReportsSceneProps::class, UserReportsSceneModel::class)
interface UserReports {
    fun load()
}

@Serializable
data class UserReportsSceneProps(
    val projectId: Long
)

@Serializable
class UserReportsSceneModel(
    val items: List<UserReportItemModel>
) {
    var isLoading = true
}

@Serializable
class UserReportItemModel(
    val reporterId: String,
    val reporterUserName: String,
    val reportedUserId: String,
    val reportedUserName: String,
    val reason: String,
    val reportedAt: Long,
)